import { EAssetType } from 'findef'
import { addressLayout, assetIdentifier, assetInformationHeader, assetNameLayout, ownership, separator } from '..'
import type { UseAssetFormLayout } from '../../types'

export const step1Layout: UseAssetFormLayout = {
  name: 'step1',
  children: (state) => {
    return [
      {
        name: 'Asset Information',
        children: [
          assetInformationHeader,
          (() => {
            switch (state.asset.type) {
              case EAssetType.REAL_ESTATE:
                return {
                  key: 'asset-information-real-estate',
                  children: [
                    {
                      attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                      children: [assetNameLayout(state), { render: 'asset.subtypes' }]
                    },
                    addressLayout
                  ]
                }
              case EAssetType.CRYPTO:
                case EAssetType.COMMODITY:
                  return {
                    key: 'asset-information-crypto',
                    children: [assetNameLayout(state), assetIdentifier(state)]
                  }
              case EAssetType.CASH:
              case EAssetType.ALTERNATIVE:
                return {
                  key: 'asset-information-cash-or-alternative',
                  children: [assetNameLayout(state), { render: 'asset.subtypes' }]
                }
              default:
                return {
                  key: 'asset-information-default',
                  children: [
                    assetNameLayout(state),
                    {
                      attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                      children: [assetIdentifier(state), { render: 'asset.subtypes' }]
                    }
                  ]
                }
            }
          })(),
          separator,
          ownership
        ]
      }
    ]
  }
}
